import { withMotion } from '@hoc/withMotion';
import Accordion from '@stories/Components/General/Accordion/Accordion';
import * as React from 'react';
import S from './AccordionContent.styles';
import { LinkButton } from '../../Buttons/GeneralButton/Button';
const AccordionContent = (props) => {
    const openDefault = props.items.find((item) => item.openAsDefault);
    return (React.createElement(S.AccordionWrapper, null,
        React.createElement(Accordion, { initialId: openDefault?.id ?? '' }, props.items.map((item) => (React.createElement(Accordion.Item, { key: item.id, id: item.id, title: item.heading },
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: item.content } }),
            item.cta && item.cta.url && (React.createElement(S.CtaArea, null,
                React.createElement(LinkButton, { branding: "textOnly", title: item.cta?.text ?? 'Read more', href: item.cta?.url, target: item.cta?.target })))))))));
};
export default withMotion(AccordionContent);
